import React, { useContext } from 'react';
import classNames from 'classnames/bind';

import { formatCents } from '../../../../../utils';
import { getCreditsApplied } from '../../../../../apps/APP/Register/tools/helpers.jsx';
import { RegistrationActions } from '../../../../../contexts/RegistrationContext/RegistrationReducer';
import { RegistrationContext } from '../../../../../contexts';
import { Checkbox } from '../../../../../components/fancyFieldsV2';
import styles from '../../../../../styles/main.module.scss';

const cx = classNames.bind(styles);

const { UPDATE_REGISTRATION_STATE } = RegistrationActions;

const CreditsAvailable = () => {
  const [registerState, registerDispatch] = useContext(RegistrationContext);

  const { creditApplied, availableCreditsAmount, creditAppliedAmount, pricingBreakdown } =
    registerState;

  const { priceCents } = pricingBreakdown || {};

  return (
    <div>
      {availableCreditsAmount > 0 ? (
        <div className={cx('register-field', 'mt-0 d-flex align-items-center')}>
          <Checkbox
            className={cx('register-checkbox')}
            noLabel
            value={creditApplied}
            onChange={val => {
              registerDispatch({
                type: UPDATE_REGISTRATION_STATE,
                update: {
                  creditApplied: val,
                  creditAppliedAmount: !creditApplied
                    ? getCreditsApplied({
                        availableCreditsAmount,
                        priceCents,
                      })
                    : 0,
                },
              });
            }}
          />
          <span className={cx('subtext')}>
            Use <b>{formatCents(availableCreditsAmount)}</b> Available Credits.
            {creditApplied && (
              <small className="d-block text-center mt-1 text-volo-grey">
                ({formatCents(availableCreditsAmount - creditAppliedAmount)} remaining)
              </small>
            )}
          </span>
        </div>
      ) : null}
    </div>
  );
};

export default CreditsAvailable;
